import { getActionTypeInitalized } from "../../clmm/util";
import { TokenInputs, BalanceAndMax } from "../common";
import { useRaydiumContext } from "../RaydiumContext";
import { useInitialRaydiumRatio } from "../util";
import { useDepositRaydiumBalances, useUpdateDepositAmount } from "./util";

export default function DepositAmounts() {
    const { depositForm, isActionTypeInitialized } = useRaydiumContext();
    const { A, B } = useDepositRaydiumBalances();

    const handleChange = useUpdateDepositAmount();
    const ratio = useInitialRaydiumRatio();

    return (
        <TokenInputs
            handleChange={handleChange}
            form={depositForm}
            ratio={ratio}
            isFetching={depositForm.status === "refetching"}
            disabled={!getActionTypeInitalized("deposit", isActionTypeInitialized)}
            getBelowInput={(side) => {
                return (
                    <BalanceAndMax
                        side={side}
                        depositRatio={ratio}
                        inputAmount={side === "A" ? depositForm.tokenAAmount : depositForm.tokenBAmount}
                        setAmount={handleChange}
                        balanceA={A.balance ?? 0}
                        balanceB={B.balance ?? 0}
                        disabled={!getActionTypeInitalized("deposit", isActionTypeInitialized)}
                    />
                );
            }}
        />
    );
}
